const reportRouter = [
    {
        path: '/report',
        component: () => import('@/layout/LayoutIndex.vue'),
        meta: { title: '报表', icon: 'report', requireAuth: true },
        name: 'report',
        redirect: '/home',
        children: [
          {
            path: '/report/deptUser',
            component: () => import('@/views/report/deptUser/deptUserIndex.vue'),
            name: 'deptUser',
            meta: { title: '部门员工报表', requireAuth: true }
          },
          {
            path: '/report/agvreport',
            component: () => import('@/views/report/agvReport/index.vue'),
            name: 'agvReport',
            meta: { title: 'AGV报告', requireAuth: true }
          }
         
        ]
    },
]

export default reportRouter;